export default __webpack_public_path__ + "static/media/sysdig.e83ce497.svg";